interface RolesDetailsConfiguration {
}

$(document).on("turbolinks:load", function () {
    const configElement = document.getElementById("roles-details");
    if (configElement) {
        const config : RolesDetailsConfiguration = JSON.parse(configElement.innerHTML);
        new RolesDetailsPage(config);
    }
});

export class RolesDetailsPage {
    constructor(config: RolesDetailsConfiguration) {
    }
}